<template>
  <div class="container">
    <div class="my-5 py-5 mx-1 mx-md-0">
      <h1>Vishwas BE IT</h1>
      <p>
        I made this website, just so that i can have a backup of all the
        materials, notes of mine and share easily. Hence this website has all
        the documents related to my BE-IT journey like Books, Notes,
        Assignments, Test Papers, Other Materials.
      </p>
      <p>
        It is just for sharing purpose, Not to make a inappropriate use of it,
        hence it is just for the help of the students
      </p>
      <p> <strong>GitHub Repo:</strong> <a class="text-primary" href="https://github.com/vishwasracharya/Vishwas-BE-IT" target="_blank" rel="noopener noreferrer">https://github.com/vishwasracharya/Vishwas-BE-IT</a></p>
      <li class="badge bg-light text-dark ms-0 mx-1">Syllabus</li>
      <li class="badge bg-light text-dark mx-1">Assignments</li>
      <li class="badge bg-light text-dark mx-1">Hand-Written Notes</li>
      <li class="badge bg-light text-dark mx-1">Papers</li>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
};
</script>
